export const Events = {
  showUserNotice: 'showUserNotice',
  loadAudioMessage: 'loadAudioMessage',
  loadFileMessage: 'loadFileMessage',
  loadVideoMessage: 'loadVideoMessage',
  loadImageMessage: 'loadImageMessage',
  forwardMessage: 'forwardMessage',
  showDevelopNotice: 'showDevelopNotice',
  showImageMessage: 'showImageMessage',
  showImage: 'showImage',
  showFile: 'showFile',
  sendFiles: 'sendFiles',
  authError: 'authError',
  reboot: 'reboot',
  messageSentToCurrentChat: 'messageSentToCurrentChat',
  messageReceived: 'messageReceived',
  settingsHeaderAction: 'settingsHeaderAction'
} as const

export type TEvents = typeof Events[keyof typeof Events]
